import { render, staticRenderFns } from "./ContentDocumentCard.vue?vue&type=template&id=ec6225c2&"
import script from "./ContentDocumentCard.vue?vue&type=script&lang=js&"
export * from "./ContentDocumentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports